import { z } from 'zod';
import { defineEndpoint } from '../define';
import { MachineSchema } from './shapes';

export const getRunnerMachine = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/machines/:machineId',
  params: z.object({ machineId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: MachineSchema }),
});
